import React, { useEffect } from "react";
import { bottle } from "../../provider/Bottle";
import { useLocation } from "react-router";

interface SignInProps {
    fromRoute?: string;
}

interface LocationState {
    from?: {
        pathname: string;
    };
}

const SignIn: React.FC<SignInProps> = ({ fromRoute }) => {
    const location = useLocation();

    useEffect(() => {
        async function init() {
            const state = (location.state as LocationState) || {};
            const from = state.from || { pathname: "/" };

            await bottle.container.UserManager.signIn(fromRoute || from.pathname);
        }
        init();
    }, [fromRoute, location.state]);

    return <div />;
};

export default SignIn;
